module.exports = __webpack_public_path__ + "img/successPic.51741644.png";